import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../AppIcon';
import { useAuth } from '../../contexts/AuthContext';

const AdminHeader = () => {
  const navigate = useNavigate();
  const { user, userProfile, signOut } = useAuth();
  const [isProfileMenuOpen, setIsProfileMenuOpen] = useState(false);

  const handleSignOut = async () => {
    try {
      await signOut();
      navigate('/admin-login');
    } catch (error) {
      console.error('Sign out error:', error);
    }
  };

  return (
    <header className="bg-background-primary border-b border-border-light sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo/Brand */}
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-primary rounded-lg flex items-center justify-center">
              <Icon name="LayoutDashboard" size={24} className="text-white" />
            </div>
            <div>
              <h1 className="text-lg font-bold text-text-primary">EpoxyViz Pro</h1>
              <p className="text-xs text-text-secondary">Admin Dashboard</p>
            </div>
          </div>

          {/* User Profile Section */}
          <div className="flex items-center gap-4">
            {/* Notifications */}
            <button className="p-2 text-text-secondary hover:text-text-primary hover:bg-background-secondary rounded-lg transition-colors duration-150">
              <Icon name="Bell" size={20} />
            </button>

            {/* User Profile Dropdown */}
            <div className="relative">
              <button
                onClick={() => setIsProfileMenuOpen(!isProfileMenuOpen)}
                className="flex items-center gap-3 p-2 hover:bg-background-secondary rounded-lg transition-colors duration-150"
              >
                <div className="w-8 h-8 bg-primary/10 rounded-full flex items-center justify-center">
                  <Icon name="User" size={16} className="text-primary" />
                </div>
                <div className="text-left hidden sm:block">
                  <p className="text-sm font-medium text-text-primary">
                    {userProfile?.full_name || user?.email?.split('@')?.[0] || 'Admin'}
                  </p>
                  <p className="text-xs text-text-secondary capitalize">
                    {userProfile?.role || 'admin'}
                  </p>
                </div>
                <Icon name="ChevronDown" size={16} className="text-text-secondary" />
              </button>

              {/* Dropdown Menu */}
              {isProfileMenuOpen && (
                <div className="absolute right-0 mt-2 w-56 bg-background-primary border border-border-light rounded-lg shadow-lg py-1">
                  <div className="px-4 py-3 border-b border-border-light">
                    <p className="text-sm font-medium text-text-primary">
                      {userProfile?.full_name || 'Admin User'}
                    </p>
                    <p className="text-xs text-text-secondary">{user?.email}</p>
                  </div>
                  <button
                    onClick={() => {
                      setIsProfileMenuOpen(false);
                      navigate('/company-profile-management');
                    }}
                    className="w-full flex items-center gap-3 px-4 py-2 text-sm text-text-secondary hover:bg-background-secondary hover:text-text-primary transition-colors duration-150"
                  >
                    <Icon name="Settings" size={16} />
                    Profile Settings
                  </button>
                  <button
                    onClick={handleSignOut}
                    className="w-full flex items-center gap-3 px-4 py-2 text-sm text-error hover:bg-error/5 transition-colors duration-150"
                  >
                    <Icon name="LogOut" size={16} />
                    Sign Out
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Close dropdown when clicking outside */}
      {isProfileMenuOpen && (
        <div
          className="fixed inset-0 z-40"
          onClick={() => setIsProfileMenuOpen(false)}
        />
      )}
    </header>
  );
};

export default AdminHeader;